export class FSInvoice {
    "DC Member Num": string = "";
    "DC SRType": string = "";
    "Payment Method": string = "";
    "DC SRSubType": string = "";
    "Status": string = "";
    "SR Created Login": string = "";
    "DC Parent Invoice Number": string = "";
}

export class ListOfDCInvoiceStatIO {
    "FS Invoice": FSInvoice = new FSInvoice();
}

export class IncomingHierarchy {
    MessageId: string = "123456";
    IntObjectName: string = "DCInvoiceStatIO";
    MessageType: string = "Integration Object";
    IntObjectFormat: string = "Siebel Hierarchical";
    ListOfDCInvoiceStatIO: ListOfDCInvoiceStatIO = new ListOfDCInvoiceStatIO();
}

export class PaymentStatementBody {
    ProcessName: string = "DC Get All Payments Statement WF";
    IncomingHierarchy: IncomingHierarchy = new IncomingHierarchy();
    Language: string = "ENU";
    PageSize: string = "10";
    StartRowNum: number = 0;
    NewQuery: string = "false";
    NoDays: string = "100";
    FromDate: string = "";
    ToDate: string = "";
}

export class PaymentStatementRequest {
    body: PaymentStatementBody = new PaymentStatementBody();
}
